import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { DataService } from '../services/data.service';
import { IMPORT_API } from './import-api.constants';

@Injectable({ providedIn: 'root' })
export class ImportMappingService {
  constructor(private dataService: DataService) {}

  getModuleFields(sourceId: number): Observable<Response> {
    const url = `${IMPORT_API.common.getModuleFields}?sourceId=${sourceId}`;
    return this.dataService.get(url, true);
  }

  autoMapFields(file: string, sourceId: number): Observable<Response> {
    return this.dataService.post(IMPORT_API.common.autoMapFields, { file, sourceId });
  }

  getHeaderNameListFromFile(file: string): Observable<Response> {
    return this.dataService.post(IMPORT_API.common.getHeaderNameListFromFile, { file });
  }

  validateFileWithTemplate(data: any): Observable<Response> {
    return this.dataService.post(IMPORT_API.common.validateFileWithTemplate, data);
  }

  validateFileHasData(data: any): Observable<Response> {
    return this.dataService.post(IMPORT_API.common.validateFileHasData, data);
  }

  getTemplateByTemplateId(templateId: string, sourceId: number): Observable<Response> {
    const url = `${IMPORT_API.common.getTemplateByTemplateId}?TemplateId=${templateId}&sourceId=${sourceId}`;
    return this.dataService.get(url, true);
  }

  deleteTemplateByTemplateId(templateId: string): Observable<Response> {
    const url = `${IMPORT_API.common.deleteTemplateByTemplateId}?TemplateId=${templateId}`;
    return this.dataService.get(url, true);
  }
}
